import React from 'react'; // Adjust import paths as needed
import CollapsibleText from '../../../components/ReviewText/collapsibleText';
import styled from 'styled-components';

const Circle = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;

  border: 2px solid #fff;
`;
const PositiveCircle = styled(Circle)`
  background: rgba(3, 198, 82, 1);
`;

const NeutralCircle = styled(Circle)`
  background: rgba(239, 205, 29, 1);
`;

const NegativeCircle = styled(Circle)`
  background: rgba(238, 19, 7, 1);
`;

const sentimentConfig = {
  positive: {
    label: {
      comment: 'Top Positive Comment',
      repost: 'Top Positive Repost',
    },
    color: 'rgb(222, 249, 233)',
    CircleIcon: PositiveCircle,
  },
  negative: {
    label: {
      comment: 'Top Negative Comment',
      repost: 'Top Negative Repost',
    },
    color: 'rgb(254, 227, 225)',
    CircleIcon: NegativeCircle,
  },
  neutral: {
    label: {
      comment: 'Top Neutral Comment',
      repost: 'Top Neutral Reposts',
    },
    color: 'rgb(255, 243, 213)',
    CircleIcon: NeutralCircle,
  },
};

const TopSentimentCard = ({ sentiment, channel, filteredData, sentiments_tab }) => {
  const config = sentimentConfig[sentiment];
  const isCommentBased = ['instagram', 'facebook', 'youtube'].includes(channel);
  const Circle = config.CircleIcon;

  const getDataPath = () => {
    const fallback = sentiments_tab || {};
    const source = filteredData || fallback;

    if (isCommentBased) {
      return source?.top_liked_comments?.[`top_${sentiment}_comments`] || {};
    } else {
      return source?.top_reposts?.[`top_${sentiment}_posts`] || {};
    }
  };

  const data = getDataPath();
  const text = isCommentBased ? data?.comment_text : data?.post_text || '';
  const link = data?.post_link || data?.link || '';
  const likes = isCommentBased
    ? data?.likes_count || 0
    : data?.post_interaction || 0;

  const hasContent = text || link;

  function formatNumber(val) {
    if (val >= 1000000) {
      return (val / 1000000).toFixed(1) + 'M';
    } else if (val >= 1000) {
      return (val / 1000).toFixed(1) + 'k';
    } else if (val > 0) {
      return val.toString();
    } else if (val == 0) {
      return 0;
    } else {
      return '';
    }
  }
  return (
    <div className={`${sentiment}Review`} style={{ color: '#292A2A' }}>
      <Circle />
      <div className="reviewText" style={{ color: '#292A2A' }}>
        {isCommentBased ? config.label.comment : config.label.repost}
        <br />
        <br />
        <CollapsibleText
          background={config.color}
          text={text || 'Insufficient Data'}
          link={link}
        />
      </div>
      <div className="reviewCount" style={{ color: '#292A2A' }}>
        {formatNumber(likes)}
        {hasContent && (
          <div className="peopleLiked">
            People <br />
            {isCommentBased ? 'Liked' : 'Reposted'}
          </div>
        )}
      </div>
    </div>
  );
};

export default TopSentimentCard;
